
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"transparent","fill-rule":"evenodd","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"id":"Person1","d":"M8 16.348c3.314 0 6 2.726 6 6.087h0v4.26h-3L10.4 34H5.6L5 26.696H2v-4.261c0-3.361 2.686-6.087 6-6.087zM8 5.26a4 4 0 110 8 4 4 0 010-8z"}}),_c('path',{attrs:{"id":"Person2","d":"M24 16.348c3.314 0 6 2.726 6 6.087h0v4.26h-3L26.4 34h-4.8l-.6-7.304h-3v-4.261c0-3.361 2.686-6.087 6-6.087zM24 5.26a4 4 0 110 8 4 4 0 010-8z"}}),_c('path',{attrs:{"id":"Person3","d":"M40 16.348c3.314 0 6 2.726 6 6.087h0v4.26h-3L42.4 34h-4.8l-.6-7.304h-3v-4.261c0-3.361 2.686-6.087 6-6.087zM40 5.26a4 4 0 110 8 4 4 0 010-8z"}}),_c('path',{attrs:{"id":"Person4","d":"M56 16.348c3.314 0 6 2.726 6 6.087h0v4.26h-3L58.4 34h-4.8l-.6-7.304h-3v-4.261c0-3.361 2.686-6.087 6-6.087zM56 5.26a4 4 0 110 8 4 4 0 010-8z"}}),_c('path',{attrs:{"id":"Person5","d":"M72 16.348c3.314 0 6 2.726 6 6.087h0v4.26h-3L74.4 34h-4.8l-.6-7.304h-3v-4.261c0-3.361 2.686-6.087 6-6.087zM72 5.26a4 4 0 110 8 4 4 0 010-8z"}})])])
          )
        }
      }
    